import { useEffect } from "react";

const applyZoomProperties = () => {
  const zoomLevel = Math.ceil((window.outerWidth - 6) / window.innerWidth * 100);

  if (zoomLevel >= 150) {
    document.body.classList.add("zoom-150");
  } else {
    document.body.classList.remove("zoom-150");
  }
};

const useRegulateBrowserZoom = () => {
  useEffect(() => {
    applyZoomProperties();
  }, []);

  useEffect(() => {
    window.addEventListener("resize", applyZoomProperties);
    return () => {
      window.addEventListener("resize", applyZoomProperties);
    };
  }, []);
};

export default useRegulateBrowserZoom;
